module.exports = __webpack_public_path__ + "static/img/step_2.899cbe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/step_2.png
// module id = nkU3
// module chunks = 1